<template>
  <div>
    <el-row style=" margin-top: 40px; margin-bottom: 70px; text-align: center">
      <span>强制更新密码时长：</span>
      <span>
        <el-input
            v-model="editForcedPasswordUpdateDuration.val1"
            placeholder="请输入强制更新密码时长"
            size="mini"
            @change="checkNumber"
            style="width: 100px;">
        </el-input>&nbsp;月
      </span>

    </el-row>
  </div>
</template>

<script>
export default {
  name: "editSecuritySetting",
  props: ["editForcedPasswordUpdateDuration"],
  methods: {
    //数字校验
    checkNumber(){
      if (!this.$checkNumber(this.editForcedPasswordUpdateDuration.val1)) {
        this.editForcedPasswordUpdateDuration.val1 = '';
        this.$message({
          message: '请输入大于0的正整数',
          type: 'warning'
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
